import * as views from './pages'

angular.module('app.agenda').config(function ($stateProvider, lazyLoadProvider) {
    $stateProvider
        .state('app.agenda', {
            abstract: true
        })
        .state('app.agenda.recebiveis', {
            abstract: true
        })
        .state('app.agenda.pagamentos', {
            abstract: true
        })
        .state('app.agenda.recebiveis.consultasBoletos', {
            url: '/processos/agendarecebivel/consultas',
            views: {
                'content@app': lazyLoadProvider.create(views.recebiveis.consultasBoletos)
            },
            data: {
                title: 'Agenda de Recebíveis',
                access: { requiredPermissions: ['AgendaRecebivel'] },
                breadcrumbs: ['Agenda de Recebíveis', 'Consultas', 'Boletos']
            }
        })
});